import { BaseDto } from './base.dto';

export class Planner extends BaseDto {
  name?: string;
  officeName?: string;
  email?: string;
  address?: string;
  phone?: string;
  extraEmail?: string;
  extraPhone?: string;
}
